<template>
    <div class="device-type-manange relative">
        <el-page-header @back="goBack" content="群成员列表"></el-page-header>
         <div class="buttons">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
        </div>

        <div style="margin: 0 0 30px 0;">
            <span>群名称：{{chatroom_name}}</span>
        </div>
        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20" style="margin: 0 0 20px 0;">
            <el-col :md="6" :lg="6" :xl="4">
                <span class="fs-14 pd-r-10">姓名：</span>
                <el-input v-model="user_name" placeholder="姓名模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="6" :xl="4">
                <span class="fs-14 pd-r-10">手机号：</span>
                <el-input v-model="mobile" placeholder="手机号模糊搜索"/>
            </el-col>
            
        </el-row>
        <!-- 表单结束 -->

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
            <el-table-column prop="user_name" label="姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="remark_name" label="群昵称" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="user_role" label="用户类型" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="mobile" label="手机号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="join_date" label="加入时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'doctorEdit'" v-if="scope.row.role != 1" @click="deleteMember(scope.row)"
                           type="text" size="mini">删除
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";

    export default {
        data() {
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                allRole: [
                    {
                        id: 1,
                        name: '特属服务对象'
                    },
                    {
                        id: 3,
                        name: '特属专家'
                    },
                ],
                user_name: '',
                chatroom_name: '',
                chatroom_id: '',
                mobile: '',
            };
        },
        created() {
            this.chatroom_id = this.$route.params.chatroom_id;
            this.chatroom_name = this.$route.params.chatroom_name;
        },
        mounted() {
            // 获取群聊成员列表
            this.getList();
        },
        methods: {
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_chatAdminServices',
                    method: 'getGroupMember',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        chatroom_id: this.chatroom_id,
                        user_name: this.user_name,
                        mobile: this.mobile,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        switch (res.data.data.list[i].user_role) {
                            case '1':
                                res.data.data.list[i].user_role = '特属服务对象';
                                break;
                            case '3':
                                res.data.data.list[i].user_role = '特属专家';
                                break;
                        }
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                this.user_name = "";
                this.mobile = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                this.getList();
            },

            // 编辑
            deleteMember(data) {
                this.$confirm('确定删除该成员吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_chatAdminServices',
                        method: 'delGroupUser',
                        pageinfo: {
                            page: this.page,
                            perpage: this.perpage,
                        },
                        params: {
                            user_id: data.user_id,
                            chatroom_id: data.chatroom_id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '删除成功',
                            duration: 1500,
                        });
                        this.getList();
                    });
                }).catch(() => {
                });
            },


            // 返回上一页
            goBack() {
                window.history.go(-1);
            },
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
</style>
